module YVR.Utilities.DOM {
	/**
	 * Determine if two elements overlap or not on the page.
	 * @param   {Object}  a The first element
	 * @param   {Object}  b The second element
	 * @returns {Boolean}   Whether or not the two elements overlap.
	 */
	export function isOverlapped(a: Element, b: Element): boolean {
		const rectA = a.getBoundingClientRect();
		const rectB = b.getBoundingClientRect();

		return !(rectA.right < rectB.left ||
			rectA.left > rectB.right ||
			rectA.bottom < rectB.top ||
			rectA.top > rectB.bottom);
	}
}
